import { render, staticRenderFns } from "./bind_code.vue?vue&type=template&id=ff1ee87a&scoped=true"
import script from "./bind_code.vue?vue&type=script&lang=js"
export * from "./bind_code.vue?vue&type=script&lang=js"
import style0 from "./bind_code.vue?vue&type=style&index=0&id=ff1ee87a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1ee87a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff1ee87a')) {
      api.createRecord('ff1ee87a', component.options)
    } else {
      api.reload('ff1ee87a', component.options)
    }
    module.hot.accept("./bind_code.vue?vue&type=template&id=ff1ee87a&scoped=true", function () {
      api.rerender('ff1ee87a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/login/bind_code.vue"
export default component.exports